import { Team } from '@/types/auth'
import { BrandingLayer, ITeamTheme } from '@/types/branding'

interface ResolveBrandingLayerParams {
  isEnabled: boolean
  eligibleBrandingTag: string | null
  isBrandingResolving: boolean
  favoriteTeam: Team | null
  teamTheme: ITeamTheme | null
}

/**
 * Precedence (first matching rule wins), consistent with base < AB < team <
 * full branding: full branding always wins when eligible, the team flag
 * gates everything else, and an unresolved orders fetch holds off the team
 * layer so it never flashes before full branding resolves.
 */
export function resolveBrandingLayer(params: ResolveBrandingLayerParams): BrandingLayer {
  const { isEnabled, eligibleBrandingTag, isBrandingResolving, favoriteTeam, teamTheme } = params

  if (eligibleBrandingTag) {
    return { kind: 'full', source: 'entitlement', tag: eligibleBrandingTag }
  }

  if (!isEnabled) {
    return null
  }

  if (isBrandingResolving) {
    return null
  }

  if (favoriteTeam && teamTheme) {
    return { kind: 'team', source: 'profile', teamId: favoriteTeam._id, theme: teamTheme }
  }

  return null
}
